var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsAwsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.736,
    height: 74.736,
    viewBox: "0 0 74.736 74.736",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(-645.632 -307.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(501.632 0.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microsoft",
    transform: "translate(144 306.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M272,35.033h35.033V2.336A2.336,2.336,0,0,0,304.7,0H272Z",
    transform: "translate(-232.296)",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M35.033,35.033V0H2.336A2.336,2.336,0,0,0,0,2.336v32.7Z",
    fill: "#f44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M35.033,272H0v32.7a2.336,2.336,0,0,0,2.336,2.336h32.7Z",
    transform: "translate(0 -232.296)",
    fill: "#2196f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M272,272v35.033h32.7a2.336,2.336,0,0,0,2.336-2.336V272Z",
    transform: "translate(-232.296 -232.296)",
    fill: "#ffc107"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(-55 76.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(722 252.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(727.015 262.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M19.4,5.883a2.216,2.216,0,0,0,.081.652,3.921,3.921,0,0,0,.234.527.319.319,0,0,1,.051.168.29.29,0,0,1-.139.22l-.461.308a.351.351,0,0,1-.19.066.337.337,0,0,1-.22-.1,2.266,2.266,0,0,1-.264-.344c-.073-.125-.146-.264-.227-.432a2.706,2.706,0,0,1-2.153,1.011,2.007,2.007,0,0,1-1.465-.527A1.882,1.882,0,0,1,14.1,6.022a1.886,1.886,0,0,1,.667-1.509,2.665,2.665,0,0,1,1.795-.571A5.8,5.8,0,0,1,17.338,4c.271.037.549.1.842.161V3.627a1.623,1.623,0,0,0-.344-1.172,1.686,1.686,0,0,0-1.194-.337,3.333,3.333,0,0,0-.791.1,5.836,5.836,0,0,0-.791.249,2.1,2.1,0,0,1-.256.1.449.449,0,0,1-.117.022c-.1,0-.154-.073-.154-.227V1.994a.463.463,0,0,1,.051-.256.548.548,0,0,1,.205-.154,4.217,4.217,0,0,1,.923-.33,4.441,4.441,0,0,1,1.143-.139,2.677,2.677,0,0,1,1.919.593,2.424,2.424,0,0,1,.608,1.8V5.883ZM16.422,7a2.374,2.374,0,0,0,.754-.132,1.632,1.632,0,0,0,.7-.469,1.163,1.163,0,0,0,.249-.469,2.63,2.63,0,0,0,.073-.637V4.982a6.117,6.117,0,0,0-.674-.125,5.519,5.519,0,0,0-.689-.044,1.689,1.689,0,0,0-1.091.293,1.021,1.021,0,0,0-.359.842A.945.945,0,0,0,16.422,7Zm5.882.791a.409.409,0,0,1-.278-.073.6.6,0,0,1-.154-.286L20.15,1.767a1.283,1.283,0,0,1-.066-.293.161.161,0,0,1,.176-.183h.718a.406.406,0,0,1,.286.073.6.6,0,0,1,.146.286L22.641,6.5l1.143-4.849a.514.514,0,0,1,.139-.286.5.5,0,0,1,.293-.073H24.8a.441.441,0,0,1,.293.073.494.494,0,0,1,.139.286l1.157,4.908,1.267-4.908a.628.628,0,0,1,.146-.286.478.478,0,0,1,.286-.073h.681a.163.163,0,0,1,.183.183.731.731,0,0,1-.015.117,1.042,1.042,0,0,1-.051.183L27.123,7.436a.562.562,0,0,1-.154.286.469.469,0,0,1-.278.073h-.63a.441.441,0,0,1-.293-.073.519.519,0,0,1-.139-.293L24.494,2.7,23.366,7.421a.572.572,0,0,1-.139.293.454.454,0,0,1-.293.073Zm9.412.2a4.847,4.847,0,0,1-1.128-.132,3.332,3.332,0,0,1-.842-.293.528.528,0,0,1-.227-.205.517.517,0,0,1-.044-.205V6.777c0-.154.059-.227.168-.227a.415.415,0,0,1,.132.022c.044.015.11.044.183.073a3.984,3.984,0,0,0,.806.256,4.4,4.4,0,0,0,.872.088A1.976,1.976,0,0,0,32.7,6.747a.789.789,0,0,0,.381-.7.713.713,0,0,0-.2-.513,1.838,1.838,0,0,0-.74-.381l-1.062-.33a2.234,2.234,0,0,1-1.172-.747,1.745,1.745,0,0,1-.366-1.062,1.63,1.63,0,0,1,.2-.813,1.883,1.883,0,0,1,.527-.6,2.325,2.325,0,0,1,.762-.381,3.192,3.192,0,0,1,.923-.125,3.677,3.677,0,0,1,.491.029c.168.022.322.051.476.081s.286.073.418.117a1.6,1.6,0,0,1,.308.132.633.633,0,0,1,.22.183.4.4,0,0,1,.066.242v.344c0,.154-.059.234-.168.234a.762.762,0,0,1-.278-.088,3.351,3.351,0,0,0-1.406-.286,1.891,1.891,0,0,0-.974.205.707.707,0,0,0-.344.652.692.692,0,0,0,.22.52,2.188,2.188,0,0,0,.806.4l1.04.33a2.228,2.228,0,0,1,1.135.7A1.657,1.657,0,0,1,34.3,5.927a1.883,1.883,0,0,1-.19.85,1.97,1.97,0,0,1-.535.645,2.361,2.361,0,0,1-.813.41A3.483,3.483,0,0,1,31.716,7.985Z",
    transform: "translate(-13.189 -1.1)",
    fill: "#252f3e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(0 8.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M21.579,120.942a15.8,15.8,0,0,1-8.921,2.725,16.14,16.14,0,0,1-10.892-4.153c-.227-.205-.022-.483.249-.322a21.632,21.632,0,0,0,19.213,1.194C21.63,120.2,21.974,120.649,21.579,120.942Z",
    transform: "translate(-1.668 -118.707)",
    fill: "#f90",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M249.005,114.284c-.308-.4-2.036-.19-2.82-.1-.234.029-.271-.176-.059-.33a4.351,4.351,0,0,1,3.9-.366c.264.33-.073,2.593-1.362,3.677-.2.168-.388.081-.3-.139C248.661,116.306,249.313,114.672,249.005,114.284Z",
    transform: "translate(-228.091 -113.192)",
    fill: "#f90",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsAwsLogo);
export default __webpack_public_path__ + "static/media/windows-aws-logo.03df3d2e21e5dc4068eb96251e6a6505.svg";
export { ForwardRef as ReactComponent };